@if (show) {
<div class="modal-overlay" (click)="onClose()">
    <div class="modal-content medium" (click)="$event.stopPropagation()">
        <div class="modal-header">
            <h3>
                <fa-icon [icon]="faTag"></fa-icon>
                <span>{{ 'TAGS.MODAL.TITLE' | translate }}</span>
            </h3>
            <button class="close-btn" (click)="onClose()">
                <fa-icon [icon]="faTimes"></fa-icon>
            </button>
        </div>
        <div class="modal-body">
            @if (tag) {
            <div class="tag-details">
                <div class="tag-preview-large">
                    <span class="tag-badge-large" [style.background-color]="tag.bg_color"
                        [style.color]="tag.text_color">
                        {{ tag.name }}
                    </span>
                </div>

                <div class="tag-description-section">
                    <label>
                        <fa-icon [icon]="faInfoCircle"></fa-icon>
                        {{ 'TAGS.FORM.DESCRIPTION' | translate }}
                    </label>
                    <div class="description-text">
                        {{ tag.description || ('COMMON.NO_NOTES' | translate) }}
                    </div>
                </div>
            </div>
            }
        </div>
        <div class="modal-footer">
            <button type="button" class="cancel-button" (click)="onClose()">
                {{ 'BUTTON.CLOSE' | translate }}
            </button>
        </div>
    </div>
</div>
}